"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const hooks_1 = require("./hooks");
/* CHANGES COUNTERS */
const ChangesCounters = {
    /* VARIABLES */
    counters: new WeakMap(),
    /* API */
    get: (store) => {
        return ChangesCounters.counters.get(store) || 0;
    },
    getMultiple: (stores) => {
        return stores.map(ChangesCounters.get);
    },
    increment: (store) => {
        ChangesCounters.counters.set(store, ChangesCounters.get(store) + 1);
    }
};
/* INIT */
hooks_1.default.store.change.subscribe(ChangesCounters.increment);
/* EXPORT */
exports.default = ChangesCounters;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbmdlc19jb3VudGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jaGFuZ2VzX2NvdW50ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxZQUFZOztBQUVaLG1DQUE0QjtBQUc1QixzQkFBc0I7QUFFdEIsTUFBTSxlQUFlLEdBQUc7SUFFdEIsZUFBZTtJQUVmLFFBQVEsRUFBRSxJQUFJLE9BQU8sRUFBa0I7SUFFdkMsU0FBUztJQUVULEdBQUcsRUFBRSxDQUFFLEtBQVksRUFBVyxFQUFFO1FBRTlCLE9BQU8sZUFBZSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUcsS0FBSyxDQUFFLElBQUksQ0FBQyxDQUFDO0lBRXJELENBQUM7SUFFRCxXQUFXLEVBQUUsQ0FBRSxNQUFlLEVBQWEsRUFBRTtRQUUzQyxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUcsZUFBZSxDQUFDLEdBQUcsQ0FBRSxDQUFDO0lBRTVDLENBQUM7SUFFRCxTQUFTLEVBQUUsQ0FBRSxLQUFZLEVBQVMsRUFBRTtRQUVsQyxlQUFlLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBRyxLQUFLLEVBQUUsZUFBZSxDQUFDLEdBQUcsQ0FBRyxLQUFLLENBQUUsR0FBRyxDQUFDLENBQUUsQ0FBQztJQUU1RSxDQUFDO0NBRUYsQ0FBQztBQUVGLFVBQVU7QUFFVixlQUFLLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUcsZUFBZSxDQUFDLFNBQVMsQ0FBRSxDQUFDO0FBRTNELFlBQVk7QUFFWixrQkFBZSxlQUFlLENBQUMifQ==